import { render, staticRenderFns } from "./AddVendorDialog.vue?vue&type=template&id=e66f76d8&scoped=true"
import script from "./AddVendorDialog.ts?vue&type=script&lang=js&external"
export * from "./AddVendorDialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66f76d8",
  null
  
)

export default component.exports